import {
	API_ENDPOINTS,
	customToast,
	DataTable,
	FileHelpers,
	formatDate,
	FormInput,
	getThemeFromUrl,
	replaceKeyWithValue,
	route,
	StringHelpers,
	SubTitle,
	Themes,
	useLangContext,
	Variants,
} from 'carrier-fe';
import { useNavigate, useParams } from 'react-router-dom';
import { ResultType } from '../../../../types/result';

function Results() {
	const navigate = useNavigate();
	const { crud, fields } = useLangContext();
	const { id } = useParams();

	const isToshiba = getThemeFromUrl() === Themes.Toshiba;

	const downloadTrainingCertificate = async (trainingResultId: string) => {
		try {
			await FileHelpers.downloadFile(
				route(API_ENDPOINTS.TRAINING.RESULT.CERTIFICATE, {
					trainingResult: trainingResultId,
				}),
				'trainingCertificate.pdf'
			);
		} catch (error: any) {
			customToast({
				variant: Variants.Danger,
				title:
					error?.response?.data?.message ||
					'Something went wrong...',
			});
		}
	};

	const handleOptionSelect = (action: any, data: ResultType) => {
		const { id = '' } = data;

		const actions: Record<string, () => void> = {
			view: () => navigate(`/training/result/${id}`),
			download: () => downloadTrainingCertificate(id),
		};

		if (typeof action === 'string' && actions[action]) {
			actions[action]();
		}
	};

	const canDownloadCertificate = (data: ResultType): boolean =>
		isToshiba && data.result === 'Passed';

	const colMapping = (data: ResultType) => {
		const cols: any = [
			{
				id: 'result',
				label: StringHelpers.title(fields?.result || 'Result'),
				value: StringHelpers.title(data.result || '-'),
				sortable: true,
			},
			{
				id: 'completed',
				label: StringHelpers.title(fields?.completed_at || 'Completed'),
				value: formatDate(data.completed_at) || '-',
				sortable: true,
			},
			{
				id: 'expires_at',
				label: StringHelpers.title(fields?.expires_at || 'Expires'),
				value: formatDate(data.expires_at) || '-',
				sortable: true,
			},
			{
				id: 'actions',
				label: StringHelpers.title(fields?.actions || 'Actions'),
				value: data.permissions.view ? (
					<FormInput
						type="select"
						label={StringHelpers.title(fields?.actions || 'Action')}
						placeholder={StringHelpers.title(
							fields?.select || 'Select'
						)}
						name="actions"
						value=""
						onChange={(value) => {
							if (!!value && typeof value === 'string') {
								handleOptionSelect(value, data);
							}
						}}
						options={[
							{
								label: StringHelpers.title(
									crud?.view || 'View'
								),
								value: 'view',
							},
							...(canDownloadCertificate(data) ? [{
								label: replaceKeyWithValue(
									crud?.buttons?.download?.default
										|| 'Download :any',
									'any',
									fields?.certificate
										|| 'Certificate'
								),
								value: 'download'
							}] : [])
						]}
						noMargin
					/>
				) : null,
			},
		];

		return cols;
	};

	return (
		<>
			<SubTitle
				title={StringHelpers.title(
					crud?.sub_titles?.previous_course_results ||
						'Previous Course Results'
				)}
				className="mb-4"
				style={{ color: '#464C5E' }}
			/>
			<DataTable<any>
				routeEndpoint={route(API_ENDPOINTS.TRAINING.COURSE.RESULT, {
					trainingCourse: String(id),
				})}
				colMapping={colMapping}
				incrementPaginationButtons
				canViewArchived={false}
				variant={Variants.Info}
        prefix="RESULTS_"
			/>
		</>
	);
}

export default Results;
